module.exports = __webpack_public_path__ + "img/icon_gnb_arrow_down.7a1cbeb8.svg";